@if (globalThemeService.backgroundImg(); as bgImage) {
  <div
    [style.background]="'url(' + bgImage + ')'"
    class="bg-image"
  ></div>
  <div
    class="bg-overlay"
    [style.opacity]="bgOverlayOpacity()"
  ></div>
}
<!--TODO move inside page container somehow -->
@if (layoutService.isShowAddTaskBar()) {
  <add-task-bar
    (closed)="layoutService.hideAddTaskBar()"
    (done)="layoutService.hideAddTaskBar()"
    (afterTaskAdd)="onTaskAdded($event)"
    [isGlobalBarVariant]="true"
    class="global"
  ></add-task-bar>
}
@if (layoutService.isShowAddTaskBar()) {
  <div
    (click)="layoutService.hideAddTaskBar()"
    @fade
    class="backdrop"
  ></div>
}
<!-- -->
@if (isShowFocusOverlay()) {
  @defer {
    <focus-mode-overlay @warp></focus-mode-overlay>
  }
} @else {
  <div
    class="app-container"
    [class.has-mobile-bottom-nav]="isShowMobileButtonNav()"
    [class.app-entrance]="isAppEntrance()"
    [dir]="isRTL ? 'rtl' : 'ltr'"
  >
    <magic-side-nav
      #magicSideNav
      [activeWorkContextId]="getActiveWorkContextId()"
    >
    </magic-side-nav>

    <main class="main-content">
      <header
        [class.isNotScrolled]="!layoutService.isWorkViewScrolled()"
        class="header-wrapper"
      >
        <main-header></main-header>

        <banner></banner>
      </header>

      <right-panel>
        <div
          #routeWrapper
          [@warpRoute]="getPage(o)"
          class="route-wrapper"
        >
          <router-outlet #o="outlet"></router-outlet>
        </div>
      </right-panel>
      <global-progress-bar></global-progress-bar>
    </main>

    <!-- Mobile Bottom Navigation -->
    @if (isShowMobileButtonNav()) {
      <mobile-bottom-nav
        [isEntrance]="isAppEntrance()"
        (toggleMobileNavEvent)="magicSideNav.toggleMobileNav()"
      ></mobile-bottom-nav>
    }
  </div>
}
<!-- -->

@if (isShowOnboardingPresets()) {
  <onboarding-preset-selection
    (presetSelected)="onPresetSelected()"
  ></onboarding-preset-selection>
}

@if (onboardingHintService.currentStep()) {
  <onboarding-hint></onboarding-hint>
}

<!-- Background context menu -->
@if (routeWrapper) {
  <context-menu
    [contextMenu]="backgroundContextMenu"
    [rightClickTriggerEl]="routeWrapper.nativeElement"
    [allowedSelectors]="'.route-wrapper, .today, .task-list-wrapper, .page-wrapper, .route-wrapper > *, .search-results'"
  ></context-menu>
}

<ng-template #backgroundContextMenu>
  <div style="min-width: 200px; max-width: 300px">
    <button
      mat-menu-item
      (click)="openSettings()"
      class="background-menu-item"
      style="width: 100%; overflow: hidden"
    >
      <mat-icon>settings</mat-icon>
      <span>{{
        (workContextService.activeWorkContextType === 'PROJECT'
          ? T.APP.CONTEXT_MENU.CHANGE_PROJECT_SETTINGS
          : T.APP.CONTEXT_MENU.CHANGE_TAG_SETTINGS
        ) | translate
      }}</span>
    </button>
  </div>
</ng-template>
